<template>
  <!--设置脱敏规则-->
    <el-dialog class="el-dialogs" append-to-body :title="title" width="650px" :close-on-click-modal="false"
               :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent
                 label-width="0px">
            <div class="text_right addMagBtn">
                <el-button type="primary" @click="addData()" size="small">新增</el-button>
            </div>
            <el-table
                    :data="searchForm.dataList"
                    v-loading="loading"
                    default-expand-all
                    size="small" height="400px"
                    class="table" ref="multipleTable" row-key='id' border>
                <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="desensitizedField" label="脱敏字段" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-form-item label-width="0px" class="setOriginalStyle"
                                      :prop="`dataList.${scope.$index}.desensitizedField`"
                                      :rules="[{required: true, message: '请选择脱敏字段', trigger: 'change'}]">
                            <div class="flex_l_c">
                                <el-select v-model="scope.row.desensitizedField" filterable class="inputWidth"
                                           @change="changeField(scope.$index)"
                                           placeholder="请选择脱敏字段"
                                           clearable>
                                    <el-option
                                            v-for="item in nodeNameList"
                                            :key="item.associationBasicId"
                                            :label="item.basicName"
                                            :value="item.associationBasicId"
                                            :disabled="item.disabled">
                                    </el-option>
                                </el-select>
                            </div>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column prop="desensitizationRule" label="脱敏规则" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-form-item label-width="0px" class="setOriginalStyle"
                                      :prop="`dataList.${scope.$index}.desensitizationRule`"
                                      :rules="[{required: true, message: '请选择脱敏规则', trigger: 'change'}]">
                            <div class="flex_l_c">
                                <el-select v-model="scope.row.desensitizationRule" class="inputWidth"
                                           placeholder="请选择脱敏规则"
                                           clearable>
                                    <el-option
                                            v-for="item in scope.row.regularList"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                        <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                                            <div class="omit">{{ item.name }}</div>
                                        </el-tooltip>
                                    </el-option>
                                </el-select>
                            </div>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column
                        fixed="right" min-width="20px"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="deleteData(scope.$index)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-form>
        <div slot="footer" class="text_right">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>提交</el-button>
        </div>
    </el-dialog>
</template>

<script>

export default {
    name: "setDesensitizationRules",
    data() {
        return {
            title: '设置脱敏规则',
            visible: false,
            loading: false,
            searchForm: {
                dataList: [],
            },
            rules: {},
            nodeNameList: [],
            selectList: [],
            basicDataId: '',
        }
    },

    methods: {
        //selectList 选中数据  basicDataId元数据模板id
        init(selectList, basicDataId) {
            this.visible = true
            this.searchForm.dataList = []
            this.selectList = selectList
            this.basicDataId = basicDataId
            this.getOtherData()
        },

        //脱敏单条数据的回显
        getDataDetail(){
            this.$axios(this.api.metadata.getByResourceId, {
                resourceId: this.selectList[0].id,
            }, 'get').then(data => {
                if (data && data.status) {
                    this.searchForm.dataList = data.data
                    this.searchForm.dataList.forEach((item,index)=>{
                        this.$set(item,'regularList',[])
                        this.changeField(index,1)
                    })
                }
            })
        },

        getOtherData() {
            //获取所有脱敏字段
            this.$axios(this.api.metadata.metadataBasicDataDetailGetDesensitized, {
                basicDataId: this.basicDataId,
            }, 'get').then(data => {
                if (data && data.status) {
                    this.nodeNameList = data.data
                    this.nodeNameList.forEach(item => {
                        this.$set(item, 'disabled', false)
                    })
                    if (this.selectList.length == 1){
                        this.getDataDetail()
                    }
                }
            })
        },

        //新增
        addData() {
            this.searchForm.dataList.push({
                desensitizedField: '',
                desensitizationRule: '',
                regularList: [],
            })
        },

        //脱敏字段的选择
        changeField(indexI,type) {
            this.nodeNameList.forEach(item1 => {
                item1.disabled = false
                this.searchForm.dataList.forEach(item2 => {
                    if (item1.associationBasicId == item2.desensitizedField) {
                        item1.disabled = true
                    }
                })
            })
            let setRow = this.searchForm.dataList[indexI]
            if (setRow.desensitizedField){
                let selDat = this.nodeNameList.filter(item=>item.associationBasicId == setRow.desensitizedField)
                this.$axios(this.api.metadata.releasesDesensitizationSelectAll, {
                    type: selDat[0].assemblyType == 'text' ? 0 : 1
                }).then(data => {
                    if (data && data.status) {
                        setRow.regularList = data.data
                    }
                })
            }else {
                setRow.regularList = []
                setRow.desensitizationRule = ''
            }
        },

        //删除
        deleteData(index) {
            this.$confirm(`确认后数据不可恢复，是否继续?`, '删除所选数据?', {
                confirmButtonText: '继续',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.searchForm.dataList.splice(index, 1)
                this.changeField()
            })
        },

        //提交
        doSubmit() {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    if (this.selectList.length == 1) {
                        this.$confirm(`提交成功后相关字段将新增脱敏规则。是否继续?`, '确认提交脱敏规则设置？', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.tijiao()
                        })
                    } else {
                        this.$confirm(`提交成功后相关字段将新增脱敏规则。如之前已设置了脱敏规则，系统自动覆盖。是否继续?`, '确认提交脱敏规则设置？', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.tijiao()
                        })
                    }
                }
            });
        },

        tijiao() {
            let resourceId = this.selectList.map(item => {
                return item.id
            })
            this.searchForm.dataList.forEach(item => {
                this.$set(item, 'basicDataId', this.basicDataId)
                // this.$set(item,'resourceId',resourceId)
            })
            this.$axios(this.api.metadata.metadataSetDesensitizationBatchSave, {
                metadataSetDesensitization: this.searchForm.dataList,
                resourceId,
            }, 'post').then(data => {
                if (data && data.status) {
                    this.$message.success('保存成功')
                    this.visible = false
                    this.$emit('refresh')
                } else {
                    this.$message.error(data.msg)
                }
            })
        },
    },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
    height: auto !important;
}

.addMagBtn {
    margin-bottom: 10px;
}

.setOriginalStyle {
    margin: 10px 0px 15px !important;
}

.inputWidth {
    width: 90%;
}
</style>